// removed by extract-text-webpack-plugin
module.exports = {"dataDemoFocus":"PromoBadge__dataDemoFocus","reward-card":"PromoBadge__reward-card","rewardCard":"PromoBadge__reward-card","reward-card-copy":"PromoBadge__reward-card-copy","rewardCardCopy":"PromoBadge__reward-card-copy","reward-card-img":"PromoBadge__reward-card-img","rewardCardImg":"PromoBadge__reward-card-img","reward-card-legal":"PromoBadge__reward-card-legal","rewardCardLegal":"PromoBadge__reward-card-legal"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/PromoBadge/PromoBadge.scss
// module id = 1806
// module chunks = 8